import { render, staticRenderFns } from "./PortfolioOverview.vue?vue&type=template&id=0a3b2d5e&scoped=true&"
import script from "./PortfolioOverview.vue?vue&type=script&lang=js&"
export * from "./PortfolioOverview.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioOverview.vue?vue&type=style&index=0&id=0a3b2d5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3b2d5e",
  null
  
)

export default component.exports